import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { SpinProps } from 'antd/es/spin';
import { FC } from 'react';

export const Preloader: FC<SpinProps> = (props) => {
	const { size = 'large', ...restProps } = props;

	return (
		<Spin
			indicator={<LoadingOutlined spin />}
			size={size}
			{...restProps}
		/>
	);
};
